export default superclass => class extends superclass {
    getFullType(type, id=this.id) {
        return type + '.' + id;
    }
}
